/**
 * Билдер SpecialOptions
 *
 * Работает только у джоина с "карточками"
 *
 */

const ACTIVE: string = 'active';
const OPENED: string = 'opened';
const SHOW: string = 'show';
const LIGHTBOX: string = 'lightbox';
const HEIGHTFIX: number = 90;

export default class HTMLElement
{
	private body: HTMLBodyElement;
	
	private mainParent: HTMLDivElement;
	
	private optionsBlock: NodeList;
	private optionsButton: NodeList;
	
	private currentBlock: HTMLDivElement;
	private currentButton: HTMLButtonElement;
	
	// Price
	/**
	 * Объект с данными из всех ценников
	 */
	private pricingData: any;
	/**
	 * Переменная с списком биткон опций
	 */
	private listBitcoinDate: HTMLUListElement;
	/**
	 * Переменная с списком ОГО коинов опций
	 */
	private listOgoDate: HTMLUListElement;
	
	public constructor()
	{
		
		this.mainParent = <HTMLDivElement>document.querySelector( 'div.special-options' );
		
		this.pricingData = [];
		
		if ( this.mainParent ){
			this.optionsBlock = <NodeList>this.mainParent.querySelectorAll( 'div.bitcoin-card,div.ogoshift-card,div.gift-card' );
			this.optionsButton = <NodeList>this.mainParent.querySelectorAll( 'button.bitcoin-pay,button.ogoshift-pay,button.gift-pay' );
			
			Array.prototype.forEach.call(
				this.optionsButton,
				( item: HTMLButtonElement ) => {
					item.addEventListener( 'click', this.optionsButtonClickHandler.bind( this ) );
				}
			);
			
			
			this.getPricingData();
			//this.setPriceingDataBitcoin();
			//this.setPriceingDataOgoshift();
		}
		
		
		
	}
	
	/**
	 * Вывод данных о ценах в блоке биткоина
	 * dry....
	 */
	private setPriceingDataBitcoin():void {
		let ceil: HTMLLIElement;
		let cent: HTMLLIElement;
		let per: HTMLLIElement;
		let tempString: string;
		
		let custonIdForBitcoin: any = ['435', '436', '347'];
		//..............................1......3......12
		let i: number = 0;
		
		/*this.pricingData.forEach((value:any, key:any) => {
			
			tempString = `
				<li>
				<form action="signup.php" method="POST">
					<input type="hidden" name="nats" value="{$nats_code}">
					<input type="hidden" name="step" value="special">
					<input type="submit" name="special[`+custonIdForBitcoin[i]+`]" value="`+value.title+`">
				</form>`;
				
			if ( value.per )
			{
				tempString += `<p class="price per">`;
			} else {
				tempString += `<p class="price">`;
			}
			tempString += `
			        <span class="dollar">$</span>
			        <span class="value">
			                <span class="ceil">`+value.ceil+`</span>
			                <span class="cent">`+value.cent+`</span>`;
			
			if ( value.per )
			{
				tempString += `<span class="per">`+value.per+`</span>`;
			}
			
			tempString += `</span></p></li>`;
			
			this.listBitcoinDate.innerHTML += tempString;
			i++;
		});*/
	}
	
	
	/**
	 * Вывод данных о ценах в блоке огокоина
	 * dry....
	 */
	private setPriceingDataOgoshift():void {
		let ceil: HTMLLIElement;
		let cent: HTMLLIElement;
		let per: HTMLLIElement;
		let tempString: string;
		let time: string = '';
		
		let newPriceCeil: string;
		let newPriceCent: string;
		
		let i: number = 0;
		
		this.pricingData.forEach((value:any, key:any) => {
			
			if ( ( value.url !== '' ) && ( value.title.indexOf('trial') === -1 ) )
			{
				time = '';
				tempString = `
					<li>
						<button
							type="button"
							onclick="location.href='`+value.url+`'">Pay with OGO Coin</button>
						<h2>`+value.title+`</h2>
						<ul class="description">`+value.desc+`</ul>`;
				
				
				if ( value.title.toLowerCase().indexOf( '12 month' ) !== -1 )
				{
					time = '* billed annually';
				}
				else if ( value.title.toLowerCase().indexOf( '3 month' ) !== -1 ){
				
					time = '* billed for 3 month';
				}
				
				// price old
				if ( value.per )
				{
					tempString += `<p class="price old per">`;
				} else {
					tempString += `<p class="price old">`;
				}
				tempString += `
				        <span class="dollar">$</span>
				        <span class="value">
				                <span class="ceil">`+value.ceil+`</span>
				                <span class="cent">`+value.cent+`</span>`;
				
				if ( value.per )
				{
					tempString += `<span class="per">`+value.per+`</span>`;
				}
				
				tempString += `</span></p>`;
				
				// price new
				if ( value.ceil === '1' )
				{
					newPriceCeil = '0';
					newPriceCent = '33';
				}
				else if ( value.ceil === '9' )
				{
					newPriceCeil = '3';
					newPriceCent = '31';
				}
				else if ( value.ceil === '14' )
				{
					newPriceCeil = '4';
					newPriceCent = '98';
				}
				else if ( value.ceil === '19' )
				{
					newPriceCeil = '6';
					newPriceCent = '65';
				}
				else if ( value.ceil === '29' )
				{
					newPriceCeil = '9';
					newPriceCent = '31';
				}
				else
				{
					newPriceCeil = String(~~(Number(value.ceil) / 3));
					newPriceCent = value.cent;
				}
				
				if ( value.per )
				{
					tempString += `<p class="price new per">`;
				} else {
					tempString += `<p class="price new">`;
				}
				tempString += `<span class="dollar">$</span><span class="value"><span class="ceil">`+newPriceCeil+`</span><span class="cent">`+newPriceCent+`</span>`;
				
				if ( value.per )
				{
					tempString += `<span class="per">`+value.per+`</span>`;
				}
				
				tempString += `</span></p>`;
				// end price
				
				if ( time !== '' )
				{
					tempString += `<p class="info">` + time + `</p>`;
				}
				
				tempString += '</li>';
				
				this.listOgoDate.innerHTML += tempString;
			}
			
			i++;
		});
	}
	
	/**
	 * Поиск данных о ценах на джон опциях.
	 * Поиск элементов для вывода
	 */
	private getPricingData():void {
		
		//this.pricingData
		this.listBitcoinDate = <HTMLUListElement>this.mainParent.querySelector( 'ul.bitcoin' );
		this.listOgoDate = <HTMLUListElement>this.mainParent.querySelector( 'ul.ogoshift' );
		
		let prices: NodeList = <NodeList>document.querySelectorAll( 'div.cards div.card p.price span.value' );
		let title: string;
		let id: string;
		let url: string;
		let desc: string;
		let ceil: HTMLSpanElement;
		let cent: HTMLSpanElement;
		let per: HTMLSpanElement;
		
		Array.prototype.forEach.call(
			prices,
			(item: HTMLDivElement) => {
				ceil = (<HTMLSpanElement>item.querySelector('.ceil'));
				cent = (<HTMLSpanElement>item.querySelector('.cent')) !== null ? (<HTMLSpanElement>item.querySelector('.cent')) : ceil;
				per = (<HTMLSpanElement>item.querySelector('.per'));
				desc = item.parentElement.parentElement.querySelector( 'ul.description' ).innerHTML;
				title = item.parentElement.parentElement.querySelector( 'h2' ).innerText;
				id = item.parentElement.parentElement.querySelector( 'button.choice-plan' ).getAttribute('data-id');
				url = item.parentElement.parentElement.querySelector( 'button.choice-plan' ).getAttribute('data-url');
				
				if ( per !== null ){
					this.pricingData.push({
						id:id,
						title: title,
						ceil: ceil.innerText,
						cent: cent.innerText,
						per: per.innerText,
						url: url,
						desc: desc
					});
				}
				else {
					this.pricingData.push({
						id:id,
						title: title,
						ceil: ceil.innerText,
						cent: cent.innerText,
						url: url,
						desc: desc
					});
				}
			}
		);
	}
	
	/**
	 * Обрабочтик клика по кнопкам Use Bitcoin, Use OGO Coin,...
	 * Перекидывает классы и запускает фукнцию рассчёта высота контента (для плавного открытия).
	 * @param {MouseEvent} e
	 */
	private optionsButtonClickHandler(e: MouseEvent):void {
		
		let btn: HTMLButtonElement = <HTMLButtonElement>e.currentTarget;
		let card: string = btn.getAttribute( 'data-card' );
		
		if ( btn.classList.contains( ACTIVE ) )
		{
			this.currentButton.classList.remove( ACTIVE );
			this.currentBlock.classList.remove( OPENED );
			this.setHeight();
		}
		else
		{
			if ( this.currentButton !== undefined )
				if ( this.currentButton.classList.contains( ACTIVE ) )
					this.currentButton.classList.remove( ACTIVE );
			
			btn.classList.add( ACTIVE );
			
			this.currentButton = btn;
			
			Array.prototype.forEach.call(
				this.optionsBlock,
				(item: HTMLDivElement) =>
				{
					if ( card === item.getAttribute('data-card' ) )
					{
						if ( this.currentBlock !== undefined )
							if ( this.currentBlock.classList.contains( OPENED ) )
								this.currentBlock.classList.remove( OPENED );
						
						this.currentBlock = item;
						
						item.classList.add( OPENED );
						
						this.setHeightFromEl(item);
					}
				}
			);
		}
	}
	
	private setHeightFromEl(el: HTMLDivElement):void
	{
		el.parentElement.style.height = el.offsetHeight + 'px';
		this.currentBlock.parentElement.classList.add(ACTIVE);
	}
	
	private setHeight():void
	{
		if ( document.documentElement.offsetWidth < 779 ) {
			this.currentBlock.parentElement.style.height = '150px';
		}
		else {
			this.currentBlock.parentElement.style.height = '65px';
		}
		
		this.currentBlock.parentElement.classList.remove(ACTIVE);
	}
	
}


